import axios from "axios";
import { handleSessionError } from '../CommonMethods/handleSessionError'
import { authHeader } from "../CommonMethods/Auth-Headers";
const { baseURL } = require("../config");

async function getCountryCodes() {
    try {
        const data = await axios.get('https://restcountries.com/v2/all?fields=name,alpha3Code,callingCodes');
        return { error: false, data: data.data };
    } catch (error) {
        return handleSessionError(error);
    }
}

async function getOrganizationUserdetails(id) {
    const idToken = sessionStorage.getItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.get(`${baseURL}organization-users/${id}?action=view&type=profile`, {
            headers: headers,
        });
        return { error: false, data: data.data };
    } catch (error) {
        return handleSessionError(error);
    }
}

async function systemConfigDataFromAdmin() {
    const idToken = sessionStorage.getItem("IdToken");
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.get(`${baseURL}system-configuration/`, {
            headers: headers,
        });
        return { error: false, data: data.data };
    } catch (error) {
        return handleSessionError(error);
    }
}

async function PostAPI(body, endpoint) {
    let payload = {};
    payload = body;
    const headers = await authHeader()
    const data = await axios.post(`${baseURL}${endpoint}`, payload, {
        headers: headers,
    });
    return { error: false, data: data };
}
async function GetAPI(endpoint) {
    const headers = await authHeader()
    const data = await axios.get(`${baseURL}${endpoint}`, {
        headers: headers,
    });
    return { error: false, data: data };
}

export const dataService = {
    getCountryCodes,
    getOrganizationUserdetails,
    systemConfigDataFromAdmin,
    PostAPI,
    GetAPI
}